import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { updateWS, refreshWs } from 'Screens/Contextualization/Workspaces/actions/Actions';
import { selectIsRefreshingWs, selectWsDetail } from 'store/Workspace/selectors';
import Importance from 'Common/Components/Importance';
import {
  Wrapper, IconButton, RefreshIcon, GroupBySlot
} from './styled';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_WORKSPACES, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import SpinnerComponent from 'Common/Components/SpinnerContainer';
import { EEFeatureSlot } from 'Common/ee/EEFeatureSlot';

const TopButtons = ({
  groupby,
  matchPrecision,
  disabled,
  onGroupByChange,
  onMatchPrecisionChange
}) => {
  const dispatch = useDispatch();
  const wsSelected = useSelector(selectWsDetail);
  const wsName = get(wsSelected, 'name', '');
  const importance = get(wsSelected, 'importance', 0);
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_WORKSPACES, PERMISSION_TYPES.UPDATE));
  const isRefreshingWs = useSelector(selectIsRefreshingWs);

  const refresh = () => {
    if (canUpdate) dispatch(refreshWs((wsName)));
  };

  return (
    <Wrapper>
      <Importance importance={ importance } callback={ (importance) => dispatch(updateWS(wsName, { importance })) } disabled={ !canUpdate } />
      <EEFeatureSlot
        featureKey="workspace-group-by-control"
        render={ (GroupByWithMatchPrecision) => (
          <GroupBySlot>
            <GroupByWithMatchPrecision
              id="ws-detail-group-by"
              label="Group By"
              value={ groupby }
              matchPrecision={ matchPrecision }
              onChange={ onGroupByChange }
              onMatchPrecisionChange={ onMatchPrecisionChange }
              disabled={ disabled }
            />
          </GroupBySlot>
        ) }
        fallback={ null }
      />
      <EEFeatureSlot
        featureKey="workspace-risk-score-profile-field"
        render={ (RiskScoreProfileDetailField) => <RiskScoreProfileDetailField disabled={ disabled } /> }
        fallback={ null }
      />
      { isRefreshingWs
        ? <SpinnerComponent size="16px" containerHeight="30px" />
        : <IconButton title="Refresh" onClick={ refresh } >
            <RefreshIcon />
          </IconButton>
      }
    </Wrapper>
  );
};

export default TopButtons;
